import { BadgeColor } from '@vendasta/galaxy/badge';
import { PersonaType } from '@vendasta/iam';

export interface CardSubtitle {
  label: string;
  date: Date;
}

export interface StatusBadge {
  label: string;
  color: BadgeColor;
}

export interface CardItem<T> {
  id: string;
  title: string;
  subtitle: CardSubtitle;
  badge: StatusBadge;
  url: string;
  data: T;
}

export enum TaskStatus {
  OPEN = 'Open',
  WAITING_ON_CUSTOMER = 'Waiting on Customer',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
}
export const Statuses = [TaskStatus.IN_PROGRESS, TaskStatus.OPEN, TaskStatus.WAITING_ON_CUSTOMER, TaskStatus.COMPLETED];

export const ProjectType = ['Project'];
export const TaskAccess = [PersonaType.digital_agent];
